import { render, staticRenderFns } from "./pin-card.vue?vue&type=template&id=cb1b4f54&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1b4f54",
  null
  
)

export default component.exports